import { Component, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import {
  FragranceCatalogProductCardComponent,
} from '@banyan/modules/catalog/components/fragrance-catalog-product-card/fragrance-catalog-product-card.component';
import { FragranceCatalogService } from '@banyan/modules/catalog/services/fragrance-catalog.service';
import { GradientComponent } from '@banyan/modules/standalone/gradient/gradient.component';
import { PaginationComponent } from '@banyan/modules/standalone/pagination/pagination.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-fragrance-catalog',
  standalone: true,
  imports: [
    GradientComponent,
    TranslateModule,
    FragranceCatalogProductCardComponent,
    RouterModule,
    MatIconModule,
    PaginationComponent,
  ],
  templateUrl: './fragrance-catalog.component.html',
  styleUrls: ['./fragrance-catalog.component.scss'],
})
export class FragranceCatalogComponent implements OnInit {
  fragranceCatalogService = inject(FragranceCatalogService);
  router = inject(Router);
  currentPage: number = 1;

  ngOnInit(): void {
    this.loadCatalog(1);
  }

  goToDetail(productId: number) {
    this.router.navigate(['/protected/fragrance-catalogue', productId]);
  }

  loadCatalog(currentPage: number) {
    this.fragranceCatalogService.getCatalog(10, currentPage);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.loadCatalog(this.currentPage);
  }
}